<template>
  <v-page-content>
    <b-card class="w-100" responsive>
      <h4>Выбор профессии</h4>
      <div class="d-flex">
        <div class="input-container w-100">
          <b-form-input placeholder="Профессия, должность, ключевые слова" v-model="searchString"></b-form-input>
          <b-card ref="promtsList" class="promts-list" >
            <div v-for="(profession, index) in professionsPromts" :key="index">
              <router-link :to="`/profession/${profession.id}`">
              {{ profession.title }} ( {{ profession.organization.title }} )
            </router-link>
            </div>
          </b-card>
        </div>
        <b-button variant="primary" class="mx-2" @click="onSearchClick">
          Поиск
        </b-button>
        <b-button variant="primary" class="" @click="onFilterClick">
          <em class="fas fa-filter"></em>
        </b-button>
      </div>
      <div class="d-flex justify-content-end m-2">
        <b-form-checkbox id="only-org-professions" v-model="onlyMarked"
          v-if="!(hasRole('content-manager') || hasRole('classroom-teacher'))">Только избранное</b-form-checkbox>
      </div>
      <div class="card-list" v-if="loaded">
        <div v-for="(profession, index) of professionsList" :key="index">
          <ProfessionCard class="" :currentProfession="profession" :currentOrganization="currentOrganization"
            :id="`profession-${profession.id}`" :isStudentPage="true" :isMarked="isProfessionMarked(profession)"
            @professionChanged="onProfessionChanged">
          </ProfessionCard>
        </div>
      </div>
      <div v-else>
        <b-alert variant="light" show class="mt-3">
          <div class="text-center">
            <b-spinner variant="primary" />
          </div>
        </b-alert>
      </div>

    </b-card>
    <ProfessionsFilterModal :editData="filtersData" :professionsList="this.professionsList"
      @onSearchClick="onSearchClick"></ProfessionsFilterModal>
  </v-page-content>
</template>

<script>
import EditProfessionModal from '@/components/admin/modals/recommendations/EditProfessionModal.vue'
import DeleteModal from '@/components/ui/modals/DeleteModal.vue'
import ProfessionsFilterModal from '@/components/common/modals/ProfessionsFilterModal.vue'
import OrganizationAPI from '@/api/organization'
import ProfessionCard from '@/components/admin/recommendations/ProfessionCard.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProfessionsList',
  components: {
    EditProfessionModal,
    DeleteModal,
    ProfessionsFilterModal,
    ProfessionCard
  },
  watch: {
    onlyMarked: {
      handler() {
        this.onOnlyMarkedClick();
      }
    },
    searchString: {
      handler() {
        console.log(this.professionsPromts.length > 0)
        if (this.searchString === '' 
          || this.searchString[this.searchString.length-1] === ' ' 
          || this.professionsPromts.length === 0
        ) {
          this.$refs.promtsList.classList.remove('promts-list-active')
          this.$refs.promtsList.style.height = `0`
          this.isProfessionsPromtsShown = false
        } else if(this.$refs.promtsList.children[0].children[0]) {
          this.$refs.promtsList.style.height = `${this.professionsPromts.length * this.$refs.promtsList.children[0].children[0].clientHeight + 40}px`
          this.$refs.promtsList.classList.add('promts-list-active')
          this.isProfessionsPromtsShown = true
        }
        
        console.dir(this.$refs.promtsList)
      }
    }
  },
  data() {
    return {
      professionsList: [],
      sortedProfessions: [],
      currentOrganization: null,
      loaded: false,
      onlyMarked: false,
      searchString: '',
      filtersData: {
        cities: [],
        subdivisions: [],
        words: '',
        gender: null,
        citizenship: null
      },
      isProfessionsPromtsShown: false
    }
  },

  computed: {
    ...mapGetters({
      currUser: 'currentUser/getCurrentUser',
      storedProfessionsList: 'profession/getProfessionsList',
      hasRole: 'currentUser/hasRole'
    }),
    professionsPromts: function () {
      return _.filter(this.professionsList, (d) => this.filtersSort(d)).slice(0, 5)
    }
  },
  async created() {
    await this.getProfessionsList();
    this.currentOrganization = (await OrganizationAPI.getOrganizationById(this.currUser.organizationId)).data;
    this.loaded = true;
  },
  methods: {
    ...mapActions({
      setProfessionsList: 'profession/fetchProfessions'
    }),
    isProfessionMarked(profession) {
      const t = profession.users.find((d) => d.id === this.currUser.id);
      if (t) return true
      return false
    },
    getCities(data) {
      this.selectOptions.cities = (_.uniqBy(data, 'organization.city')).map((org) => org.organization.city).sort()
    },
    onFilterClick() {
      this.$bvModal.show('professionsFilterModal')
    },
    async onSearchClick() {
      for (const profession of this.professionsList) {
        if (this.filtersSort(profession))
          document.getElementById(`profession-${profession.id}`).classList.remove('d-none')
        else
          document.getElementById(`profession-${profession.id}`).classList.add('d-none')
      }
    },
    filtersSort(profession) {
      return this.searchStringSorted(profession)
        && this.citiesSorted(profession)
        && this.subdivisionsSorted(profession)
        && (this.markedSorted(profession))
        && this.genderSort(profession)
        && this.citizenshipSort(profession);
    },
    async getProfessionsList() {
      if (this.$store.state.profession.professions === null
        || !_.isEqual(this.$store.state.profession.professions, this.professionsList)) {
        this.isLoaded = false;
        await this.setProfessionsList();
        this.isLoaded = true;
      }
      this.professionsList = _.sortBy(this.storedProfessionsList, 'title');
    },
    searchStringSorted(profession) {
      if (this.searchString === '')
        return true;
      const fullDescription = (profession.title + profession.description + profession.organization.title + profession.organization.city).toLowerCase();
      const splittedSearchString = this.searchString.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '').split(' ');
      for (const searchParam of splittedSearchString) {
        if (fullDescription.includes(searchParam.toLowerCase())) {
          return true
        }
      }
      return false
    },
    citiesSorted(profession) {
      if (this.filtersData.cities.length === 0) {
        return true
      }
      if (this.filtersData.cities.includes(profession.organization.city)) {
        return true
      }
      return false
    },
    subdivisionsSorted(profession) {
      if (this.filtersData.subdivisions.length === 0)
        return true
      if (this.filtersData.subdivisions.map((d) => d.id).includes(profession.organization.id))
        return true
      return false;
    },
    onOnlyMarkedClick() {
      if (this.onlyMarked) {
        //this.professionsList = _.filter(this.storedProfessionsList, (d) => this.isProfessionMarked(d))
        for (const profession of this.professionsList) {
          if (!this.isProfessionMarked(profession)) {
            document.getElementById(`profession-${profession.id}`).classList.add('d-none')
          }
        }
      } else {
        //this.professionsList = _.filter(this.storedProfessionsList, (d) => this.filtersSort(в))
        for (const profession of this.professionsList) {
          if (!this.isProfessionMarked(profession) && this.filtersSort(profession)) {
            document.getElementById(`profession-${profession.id}`).classList.remove('d-none')
          }
          else if (!this.isProfessionMarked(profession) && !this.filtersSort(profession))
            document.getElementById(`profession-${profession.id}`).classList.add('d-none')
        }
      }
    },
    markedSorted(profession) {
      if (this.onlyMarked) {
        if (this.isProfessionMarked(profession))
          return true
        return false
      }
      else
        return true
    },
    genderSort(profession) {
      if (this.filtersData.gender === null)
        return true
      if (profession.gender === this.filtersData.gender.value) {
        return true
      }
      return false
    },
    citizenshipSort(profession) {
      if (this.filtersData.citizenship === null)
        return true
      if (profession.citizenship.includes(this.filtersData.citizenship.value)) {
        return true
      }
      return false
    },
    getFilterValues(data) {
      this.filtersData = data;
    },
    async onProfessionChanged() {
      await this.setProfessionsList();
      await this.getProfessionsList();
    }
  }
}
</script>

<style scoped lang="scss">
.ag-grid-olympics-list {
  height: calc(100vh - 230px);
}

.prof-organization {
  color: gray;
}

.icons-main-color {
  color: #017ac3;
}

.prof-item {
  margin-bottom: 1rem;
}

.prof-item:first-of-type {
  margin-top: 0;
  margin-bottom: 5px;
}

.prof-item:last-of-type {
  margin-bottom: 5px;
}

.promts-list {
  position: absolute;
  z-index: 10;
  top: 37px;
  width: 100%;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
}

.promts-list-active {
  visibility:visible;
  transition: all 0.3s ease-in-out;
}

.input-container {
  position: relative;
}
</style>
